<template>
    <div>
        <div class="filterbox">
                <div class="tourTop" v-if="flag=='owner'">
                   <ul>
                        <li><span>帐号：</span><Input v-model="upobj.userName" placeholder="请输入帐号" style="width: 300px" /></li>
                        <li><span>密码：</span><Input v-model="upobj.password" placeholder="请输入密码" style="width: 300px" disabled /></li>
                        <li><span>姓名：</span><Input v-model="upobj.realname" placeholder="请输入姓名" style="width: 300px" /></li>
                        <li><span>联系电话：</span><Input v-model="upobj.phone" placeholder="请输入联系电话" style="width: 300px" /></li>
                        <li><span>所属企业: </span><Select v-model="upobj.orgId" style="width:300px;" @on-change="companyIdchange">
                            <Option v-for="item in companyTypeList" :value="item.companyId" :key="item.companyId">{{ item.name }}</Option>
                            </Select>
                        </li>
                        <li><span>所属门店：</span><Select v-model="upobj.shopId" style="width:300px;">
                            <Option v-for="item in storeList" :value="item.storeId" :key="item.storeId">{{ item.storeName }}</Option>
                            </Select>
                        </li>
                        <li><span>角色: </span><Select v-model="upobj.roleId" style="width:300px;">
                            <Option v-for="item in roleList" :value="item.roleId" :key="item.roleId">{{ item.roleName }}</Option>
                            </Select>
                        </li>
                        <li>
                            <button @click="creataccount">提交</button>
                        </li>
                   </ul>

                </div>
                <div class="tourTop" v-if="flag=='other'">
                   <ul>
                        <li><span>注册帐号：</span><Input v-model="upobj.userName" placeholder="请输入帐号" style="width: 300px" /></li>
                        <li><span>密码：</span><Input v-model="upobj.password" placeholder="请输入密码" style="width: 300px" disabled /></li>
                        <li><span>姓名：</span><Input v-model="upobj.realname" placeholder="请输入姓名" style="width: 300px" /></li>
                        <li><span>性别：</span><RadioGroup v-model="upobj.sex">
        <Radio label="1" style="margin-right:100px;" >男</Radio>
        <Radio label="2"  >女</Radio>
    </RadioGroup></li>
                        <li><span>身份证号：</span><Input v-model="upobj.idCardNum" placeholder="请输入身份证号" style="width: 300px" /></li>
                        <li><span>联系电话：</span><Input v-model="upobj.phone" placeholder="请输入联系电话" style="width: 300px" /></li>
                        <li><span>执业证号：</span><Input v-model="upobj.zhiyeNum" placeholder="请输入执业证号" style="width: 300px" /></li>
                        <li><span>从业年限：</span><Input v-model="upobj.congyeYear" placeholder="请输入从业年限" style="width: 280px;margin-right:5px;" />年</li>
                        <li><span>证书有效期：</span><DatePicker
                                format="yyyy-MM-dd"
                                type="date"
                                placeholder="请选择日期"
                                style="width:300px; height:36px;"
                                @on-change="choosetimetwo"
                            ></DatePicker></li>
                        <li><span>通讯地址：</span><Input v-model="upobj.address" placeholder="请输入通讯地址" style="width: 300px" /></li>
                        <li><span>角色：</span><Select v-model="upobj.roleId" style="width:300px;">
                            <Option v-for="item in roleList" :value="item.roleId" :key="item.roleId">{{ item.roleName }}</Option>
                            </Select>
                        </li>
                        <span style="display:none;">{{upobj.zhiyeImg}}</span><span style="display:none;">{{upobj.avatar}}</span>
                        <li  class="upload_box">
                                <div class="upload_item">
                                    <img
                                    src="@/assets/img/upload.png"
                                    class="upload-img"
                                    v-if="!upobj.zhiyeImg">
                                    <img :src="upobj.zhiyeImg" alt="" v-else class="upload-img">
                                    <input name="fileupload" type="file" @change="uploadListchange($event, 'imgInput1')" id="imgInput1">
                                    <p class="upload-pic-des">执业证照片</p>
                                </div>

                                <div class="upload_item" style="margin-left:20px;cursor: pointer;">
                                    <img
                                    src="@/assets/img/upload.png"
                                    class="upload-img"
                                    v-if="!upobj.avatar"
                                    >
                                    <img :src="upobj.avatar" alt="" v-else  class="upload-img">
                                    <input name="fileupload" type="file" @change="uploadListchange($event, 'imgInput2')" id="imgInput2">
                                    <p class="upload-pic-des">头像照片</p>
                                </div>
                        </li>
                        <li>
                            <button @click="creatOtheraccount">提交</button>
                        </li>
                   </ul>

                </div>
        </div>
    </div>
</template>
<script>
import {companyTypeList} from '@/utils/commondata';
import { admin } from '@/api/admin'
import { globelurl , upimg } from "@/api/axios.js";
export default {
    name: 'HelloWorld',
    props: {
        msg: String
    },
    data(){
        return{

            // 个人资料
            img:'',
            flag:'',
            btnclick:true,
            companyTypeList:[],
            roleList:[],
            storeList:[],
            upobj:{
                password:'111111',
            }
        }
    },
    mounted(){
        if(this.$route.path=='/accountmanagement/othercreat'){
            this.flag='other';
            this.$set(this.upobj,'zhiyeImg','');
            this.$set(this.upobj,'avatar','');
            // this.upobj.zhiyeImg='';
            // this.upobj.avatar='';
            this.upobj.sex='1';
            this.getroleList();
        }else{
            this.getroleList();
            this.orgList();
            this.flag='owner';
        }

    },
    methods:{
        companyIdchange(val){
            this.storeList=[];
            this.getstoreList(val);
        },
        orgList(){
            admin.companySelect().then(res=>{
                if(res.data.success==true){
                    this.companyTypeList=res.data.result;
                }
            })
        },
      getroleList(){
          admin.getroleselect().then(res=>{
              if(res.data.success==true){
                  this.roleList=res.data.result;
              }
          })
      },
      getstoreList(id){
          admin.getstoreselect(id).then(res=>{
              if(res.data.success==true){
                  this.storeList=res.data.result;
              }
          })
      },
      creataccount(){
          if(!this.btnclick){
            this.$Message.error('已提交，请稍候');
            return;
          }
          let roleCode='';
          let orgCode='';
          var reg = new RegExp("[\\u4E00-\\u9FFF]+","g");
          var regex=/^[A-Za-z0-9_\_]+$/ig;
          if(this.upobj.roleId){
              for(var i=0;i<this.roleList.length;i++){
                  if(this.roleList[i].roleId==this.upobj.roleId){
                      roleCode=this.roleList[i].roleCode;
                  }
              }
          }
          if(this.upobj.orgId){
              for(var i=0;i<this.companyTypeList.length;i++){
                  if(this.companyTypeList[i].companyId==this.upobj.orgId){
                      orgCode=this.companyTypeList[i].strA;
                  }
              }
          }
          if(!this.upobj.userName){
              this.$Message.error('请输入帐号');
              return;
          }
          if(!regex.test(this.upobj.userName)){
              this.$Message.error('帐号只能包括数字、字母、下划线');
              return;
          }
        //   if(reg.test(this.upobj.userName)){
        //         this.$Message.error("帐号不能包含文字");
        //         return false;
        //     }
          if(this.upobj.userName.length>20){
              this.$Message.error('帐号不能超过20个字');
              return;
          }
          if(!this.upobj.realname){
              this.$Message.error('请输入姓名');
              return;
          }
          if(this.upobj.realname.length>10){
              this.$Message.error('姓名不能超过10个字');
              return;
          }
          if(!this.upobj.phone){
              this.$Message.error('请输入联系电话');
              return;
          }
        //   if (this.upobj.phone && (!(/^[1](([3][0-9])|([4][5-9])|([5][0-3,5-9])|([6][5,6])|([7][0-8])|([8][0-9])|([9][1,8,9]))[0-9]{8}$/).test(this.upobj.phone))) {
        //     this.$Message.error('请正确的联系电话');
        //     return;
        //   }
            if (isNaN(+this.upobj.phone) || this.upobj.phone.length!=11) {
            this.$Message.error('请正确的联系电话');
            return;
          }

          // if(this.upobj.roleId =='64cd7fa446cdc952b8ef7ab1b5c3f454'){
          //
          // }
          // else{
          //
          //        if(roleCode=='yuejuManager' || roleCode=='yuejuStoreManager' || roleCode=='yuejuAgent' || roleCode=='dataChecker' ||
          //        roleCode=='netSignWindow' || roleCode=='estateVerifyWindow' || roleCode=='fundSupervisionWindow' || roleCode=='yuejuQZ' || roleCode=='custom' || roleCode=='yuejuSigning' || roleCode=='yuejuSigningAudit' || roleCode=='superManager' ){//系统管理员
          //       if(!this.upobj.orgId){
          //           this.$Message.error('请选择企业');
          //           return;
          //       }
          //       if(roleCode=='yuejuStoreManager' || roleCode=='yuejuAgent'){
          //           if(!this.upobj.shopId){
          //               this.$Message.error('请选择门店');
          //               return;
          //           }
          //       }else if(roleCode=='dataChecker' || roleCode=='netSignWindow' || roleCode=='estateVerifyWindow' || roleCode=='fundSupervisionWindow' || roleCode=='yuejuQZ' || roleCode=='superManager'){//系统管理员
          //
          //       }
          //       if(orgCode!=4){
          //           this.$Message.error('此角色只能选择悦居企业');
          //           return;
          //       }
          // }else{
          //       if(!this.upobj.orgId){
          //           this.$Message.error('请选择企业');
          //           return;
          //       }
          //       if( roleCode=='thirdAgencyStoreManager' || roleCode=='thirdAgent'){
          //           if(!this.upobj.shopId){
          //               this.$Message.error('请选择门店');
          //               return;
          //           }
          //       }else{
          //
          //       }
          //       if(orgCode==4){
          //               this.$Message.error('此角色不能选择悦居企业');
          //               return;
          //       }
          // }
          //
          // }
          if(!this.upobj.roleId){
              this.$Message.error('请选择角色');
              return;
          }
          this.btnclick=false;
          admin.creatAccount(this.upobj).then(res=>{
              this.btnclick=true;
              if(res.data.success==true){
                  this.$router.go(-1);

              }else{
                  this.$Message.error(res.data.message);
              }
          });
      },
      choosetimetwo(val){
          this.upobj.certificateExpirationTime=val;
      },
      uploadListchange(e,id){
      for(var i=0;i<e.target.files.length;i++){
                var file=e.target.files[i];
                if(((file.size)/ 1024) >10240){
                    this.$Message.error('文件太大了，不得超过10M');
                    return;
                }
                var param=new FormData();
                param.append('file',file,file.name);//通过append向form对象添加数据
                upimg(param).then(res =>{
                    if(res){
                        document.getElementById(id).value="";
                        if(id=='imgInput1'){
                            this.$set(this.upobj,'zhiyeImg',globelurl+res.data.result.pathList[0])
                        //   this.upobj.zhiyeImg=globelurl+res.data.result.pathList[0];
                        }else if(id=='imgInput2'){
                            this.$set(this.upobj,'avatar',globelurl+res.data.result.pathList[0])
                        //   this.upobj.avatar=globelurl+res.data.result.pathList[0];
                        }
                    }
                })
            }
    },
      creatOtheraccount(){
        //   if(this.upobj.roleId){
        //       for(var i=0;i<this.roleList.length;i++){
        //           if(this.roleList[i].roleId==this.upobj.roleId){
        //               roleCode=this.roleList[i].roleCode;
        //           }
        //       }
        //   }
        if(!this.btnclick){
            this.$Message.error('已提交，请稍候');
            return;
        }
        var reg = new RegExp("[\\u4E00-\\u9FFF]+","g");
          if(!this.upobj.userName){
              this.$Message.error('请输入注册帐号');
              return;
          }
          if(this.upobj.userName.length>20){
              this.$Message.error('注册帐号不能超过20个字');
              return;
          }
          if(!this.upobj.realname){
              this.$Message.error('请输入姓名');
              return;
          }
          if(this.upobj.realname.length>10){
              this.$Message.error('姓名不能超过10个字');
              return;
          }
        if(!this.upobj.phone){
              this.$Message.error('请输入联系电话');
              return;
          }
            if (isNaN(+this.upobj.phone) || this.upobj.phone.length!=11) {
            this.$Message.error('请正确的联系电话');
            return;
          }
        //   if (this.upobj.phone && (!(/^[1](([3][0-9])|([4][5-9])|([5][0-3,5-9])|([6][5,6])|([7][0-8])|([8][0-9])|([9][1,8,9]))[0-9]{8}$/).test(this.upobj.phone))) {
        //     this.$Message.error('请正确的联系电话');
        //     return;
        //   }
        //   if(!this.upobj.idCardNum){//身份证   不能超过20个字
        //     this.$Message.error('请填写身份证号');
        //     return;
        //   }
          if(reg.test(this.upobj.idCardNum)){
              this.$Message.error('身份证号不能包含文字');
                return;
          }
          if(this.upobj.idCardNum.length!=18){
              this.$Message.error('身份证号应为18位');
                return;
          }
        //   if(!this.upobj.zhiyeNum){//执业证    不能超过20个字
        //     this.$Message.error('请填写执业证号');
        //     return;
        //   }
         if(reg.test(this.upobj.zhiyeNum)){
             this.$Message.error('执业证号不能包含文字');
            return;
          }
          if(this.upobj.zhiyeNum.length>20){
              this.$Message.error('执业证号不能超过20个字');
                return;
          }
          //从业年限
          if(isNaN(this.upobj.congyeYear)){
              this.$Message.error('请输入正确的从业年限');
                return;
          }
          if(this.upobj.address.length>50){//通讯地址
            this.$Message.error('通讯地址不能超过50个字');
            return;
          }
          if(!this.upobj.roleId){
              this.$Message.error('请选择角色');
              return;
          }
          if(!this.upobj.zhiyeImg){
              this.$Message.error('请选择执业证照片');
              return;
          }
          if(!this.upobj.avatar){
              this.$Message.error('请选择头像照片');
              return;
          }
          this.btnclick=false;
          admin.creatAccount(this.upobj).then(res=>{
              this.btnclick=true;
              if(res.data.success==true){
                  this.$router.go(-1);

              }else{
                  this.$Message.error(res.data.message);
              }
          });
      },
    }
}
</script>

<style scoped>
    .filterbox{
        height: 226px;
        box-sizing: border-box;
        background-color: #ffffff;
        border-radius: 4px;
    }


    .tourTop{
        padding: 40px 40px 0 40px;
        overflow: hidden;
    }

    .tourTop ul {
        overflow: hidden;
    }
    .tourTop>ul>li{
        width:100%;
        margin:30px 0
    }
    .tourTop ul li span{
        width:100px;
        display:inline-block;
    }


  .tourTop ul li button {
        width: 140px;
        height: 42px;
        background-color: #3569fd;
        border-radius: 4px;
        text-align:center;
        color: #fff;
        line-height:42px;
        margin-left: 100px;
   }

   /* 个人资料 */
    .content{
        width: 700px;
        margin:145px auto 60px;
    }
    .left{
        width: 500px;
        display: inline-block;
    }
    .right{
        display: inline-block;
        vertical-align: top;
    }
    .create_form_item {
        margin-bottom: 30px;
    }

    .create_form_item .require {
        color: #ff1812;
        font-size: 14rpx;
    }

    .create_form_item .title {
        display: inline-block;
        color: #101d37;
        font-size: 14px;
        margin-left: 5px;
        width: 85px;
    }

    .create_form_item input {
        color: #101d37;
        font-size: 14px;
        width: 243px;
        height: 36px;
        border-radius: 4px;
        border: solid 1px #d9d9d9;
        padding-left: 20px;
    }

    .imgupload{
        width: 160px;
        height: 214px;
        position: relative;
    }
    .imgupload input {
        font-size: 14px;
        width: 160px;
        height: 214px;
        opacity: 0;
        color: transparent;
        position: absolute;
        top: 0;
        left:0;
    }

    /* upload*/
.upload-img {
  width: 130px;
  height: 130px;
}
.upload_box {
  display: flex;
  flex-direction: row;
}
.upload_item {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}
.upload_item input{
  background-color: transparent;
  opacity: 0;
  width: 130px;
  height: 130px;
  position: absolute;
  top: 0;
  left:0;

}
.upload-pic-des {
  text-align: center;
  margin-top: 10px;
}
</style>


